// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { equipmentModelId } from './EquipmentModel';
import { invLocationId } from './InvLocation';
import { equipmentStatusEnum } from './EquipmentStatusEnum';
import { calendarDate } from '../../calendar-date';
import { operatorId } from './Operator';
import { brewcontrolWorkspaceId } from './BrewcontrolWorkspace';
import { brewcontrolConfigVersionId } from './BrewcontrolConfigVersion';
import { z } from 'zod';
export const equipmentId = (z.number());
export const equipment = z.object({
    id: equipmentId,
    equipment_model_id: equipmentModelId,
    name: z.string(),
    serial_number: z.string().nullable(),
    location_id: invLocationId.nullable(),
    status: equipmentStatusEnum,
    commissioned_at: calendarDate.nullable(),
    decommissioned_at: calendarDate.nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    brewcontrol_workspace_id: brewcontrolWorkspaceId.nullable(),
    brewcontrol_wiring_version_id: brewcontrolConfigVersionId.nullable(),
});
export const equipmentInitializer = z.object({
    id: equipmentId.optional(),
    equipment_model_id: equipmentModelId,
    name: z.string(),
    serial_number: z.string().optional().nullable(),
    location_id: invLocationId.optional().nullable(),
    status: equipmentStatusEnum.optional(),
    commissioned_at: calendarDate.optional().nullable(),
    decommissioned_at: calendarDate.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    brewcontrol_workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    brewcontrol_wiring_version_id: brewcontrolConfigVersionId.optional().nullable(),
});
export const equipmentMutator = z.object({
    id: equipmentId.optional(),
    equipment_model_id: equipmentModelId.optional(),
    name: z.string().optional(),
    serial_number: z.string().optional().nullable(),
    location_id: invLocationId.optional().nullable(),
    status: equipmentStatusEnum.optional(),
    commissioned_at: calendarDate.optional().nullable(),
    decommissioned_at: calendarDate.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    brewcontrol_workspace_id: brewcontrolWorkspaceId.optional().nullable(),
    brewcontrol_wiring_version_id: brewcontrolConfigVersionId.optional().nullable(),
});
//# sourceMappingURL=Equipment.js.map